// /components/editor/extensions/mentionExtension.ts
import Mention from '@tiptap/extension-mention';
import { MentionEditorExtension } from '../components/mention/mention-editor-extension';

export const MentionExtension = Mention.extend({
  parseHTML() {
    return [
      {
        tag: 'a.mention',
        getAttrs: (dom) => {
          const element = dom as HTMLElement;
          const href = element.getAttribute('href');
          const id = href?.split('/').pop();
          const label = element.textContent?.replace('@', '') || '';
          return { id, label };
        },
      },
    ];
  },

  renderHTML({ node }) {
    return [
      'a',
      {
        href: `users/${node.attrs.id}`,
        contenteditable: 'false',
        target: '_blank',
        class: 'mention',
      },
      `@${node.attrs.label}`,
    ];
  },
}).configure({
  HTMLAttributes: { class: 'mention' },
  suggestion: MentionEditorExtension(),
});
